import React from "react";
import { Routes, Route, useLocation, Navigate, useNavigate } from "react-router-dom";
import { Viewer } from "components/auth/types";
import ContainerWithSidebar from "components/common/layout/ContainerWithSidebar";
import { Sidebar } from "./components/sidebar";
import { ApplicationCount } from "./components/application-count";
import { ApplicationSource } from "./components/application-source";
import { ApplicationDob } from "./components/application-dob";
import { ApplicationFraud } from "./components/application-fraud";
import { UserStats } from "./components/user-stats";
import { ApplicationStatus } from "./components/application-status";
import { ApplicationRace } from "./components/application-race";
import { ApplicationEthnicity } from "./components/application-ethnicity";
import { ApplicationGender } from "./components/application-gender";

type Props = { viewer: Viewer; }

export const Reports: React.FC<Props> = ({ viewer }) => {
  const navigate = useNavigate();
  const location = useLocation();
  if (location.pathname.match(/\/dash\/manager\/reports\/?$/)) {
    navigate("/dash/manager/reports/applications-received", { replace: true });
  }

  return (
    <ContainerWithSidebar>
      <Sidebar viewer={viewer} />
      <Routes>
        <Route path="/applications-received" element={<ApplicationCount />} />
        <Route path="/application-source" element={<ApplicationSource />} />
        <Route path="/application-status" element={<ApplicationStatus />} />
        <Route path="/application-dob" element={<ApplicationDob />} />
        <Route path="/application-race" element={<ApplicationRace />} />
        <Route path="/application-ethnicity" element={<ApplicationEthnicity />} />
        <Route path="/application-gender" element={<ApplicationGender />} />
        {viewer.isSupervisor && <Route path="/fraud-detection" element={<ApplicationFraud />} />}
        {viewer.isSupervisor && <Route path="/user-stats" element={<UserStats />} />}
        <Route path="/" element={<Navigate to="/dash/manager/reports/applications-received" replace />} />
      </Routes>
    </ContainerWithSidebar>
  );
};
